import './PlaqueFrame.css';
import plaqueBackgroundImg from './plaque_background.png';
import pauseTextSvg from './pause_text.svg';

/** From Figma plaque_small (137:314) — фон + pause_text (137:320). */
export function PlaqueFrame() {
  return (
    <div className="pause-plaque-frame" aria-hidden>
      <img
        className="pause-plaque-frame__background"
        src={plaqueBackgroundImg}
        alt=""
        draggable={false}
      />
      <img
        className="pause-plaque-frame__text"
        src={pauseTextSvg}
        alt=""
        draggable={false}
      />
    </div>
  );
}
